import React, { Component } from 'react'
import FixedView from '../FixedView'
import StagesManager from '../StagesManager'
import IntractionActionsList from '../IntractionActionsList'
import { checkPermission, checkTranslation, translate } from '../../utils/useful'
import importedIcons from '../inputs/icons'

export default class ViewsMenu extends Component {


  changeView = (prop) => {
    // console.log('proppppppppp1',JSON.parse(JSON.stringify(prop)))

    this.props.functionsHandler(null, 'changeView', JSON.parse(JSON.stringify(prop)))
    this.fixedView.hideView()
    // this.props.changeView(prop, All)
    // this.setState({ viewAll: All })
    // if (!All?.settings?.stacked) {
    //   this.stackedFixedView.stacedModal.showModal()
    // }
    // this.viewFixedView.hideView()
    // this.props.functionHandler(prop, All)

  }


  openAddView = () => {

    this.props.functionsHandler(null, 'openAddView')
    this.fixedView.hideView()

    // this.addView.openSidebar()
  }



  render() {


    return (
      <>
        <button className=' flexcc dark-blur-hover px-2 py-1 br-5' ref={el => this.setting = el} onClick={() => { this.fixedView.showView() }} style={{ color: this.props.colors?.textColor ?? '#000', }}>
          <p className=' font-size-13 text-semibold'>{translate('Views')}</p>
          {this.props.frame?.views?.length > 0 && (
            <div className='br-20 mld-1 flexcc ' style={{ backgroundColor: !this.props.colors?.iconInvert ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.1)', height: 20, minWidth: 20 }}>
              <p className='text-smaller text-semibold '>{this.props.frame?.views?.length}</p>
            </div>
          )}
        </button>
        <FixedView width={this.props.width} zIndex={10} ref={el => this.fixedView = el} nodeRef={this.setting} xOffset={this.props.language == 'fa' ? 195 : -10} bottomOffset={0} topOffset={0} maxWidth={260} >
          <div className='bg-white br-10 p-1 shadow-3'>
            <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}>
              <div width={this.props.width} isLoading={this.props.isLoading} stage={0} stageName={'view'} className=' p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'auto', }}>
                {Array.isArray(this.props.frame?.views) && this.props.frame?.views.map((view, index) => {
                  // console.log('proppppppppp2',index,view)
                  return (
                    <div className='mb-1' key={index}>
                      <IntractionActionsList language={this.props.language} onClick={() => this.changeView(view)} data={{ title: checkTranslation(view.name), icon: '/assets/icons/applets/database/' + view.type + '.svg' }} />
                    </div>
                  )
                })}
                {checkPermission(this.props.permissions, `frames.${this.props.frame?._id}.view`, 'create') && (
                  <>
                    <div className={this.props.frame?.views ? ' pt-1 ' : ''} style={{ borderTop: this.props.frame?.views ? "1px solid #eee" : "" }}>
                      <IntractionActionsList language={this.props.language} onClick={() => this.openAddView()} data={{ title: "{{lang}}Create New View", icon: importedIcons.plus }} />
                    </div>
                  </>
                )}
              </div>
            </StagesManager>
          </div>
        </FixedView>
      </>
    )
  }
}
